import { render } from "./section-navigation.vue?vue&type=template&id=6fed2316"
import script from "./section-navigation.vue?vue&type=script&lang=js"
export * from "./section-navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__